'use client';

import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputField } from '@pickleballinc/react-ui';
import { useRef, useState } from 'react';

import { Button } from '@/components/atoms';

interface SearchBarProps {
	placeholder?: string;
	onSearch: (searchTerm: string) => void;
	buttonText?: string;
}

export const SearchBar = ({ placeholder = 'Search...', onSearch, buttonText = 'Search' }: SearchBarProps) => {
	const [searchTerm, setSearchTerm] = useState('');
	const inputRef = useRef<HTMLInputElement>(null);

	const handleSearch = () => {
		onSearch(searchTerm);
	};

	const clearSearch = () => {
		setSearchTerm('');
		inputRef.current?.focus();
	};

	return (
		<div className="relative flex justify-between ">
			<FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 size-5 -translate-y-1/2 cursor-pointer text-gray-400" />

			<div className="w-full  pr-4">
				<InputField
					ref={inputRef}
					tabIndex={0}
					type="text"
					value={searchTerm}
					onChange={(e) => setSearchTerm(e.target.value)}
					placeholder={placeholder}
					className="w-full rounded-lg  pl-6 pr-4"
					focusColor="orange"
				/>
				{searchTerm !== '' && (
					<FontAwesomeIcon
						onClick={clearSearch}
						icon={faClose}
						className="absolute right-28 top-1/2 size-5 -translate-y-1/2 cursor-pointer text-gray-400"
					/>
				)}
			</div>

			<Button
				onClick={handleSearch}
				className="w-auto border border-gray-200 bg-white px-4 py-[10px] text-sm font-semibold text-black shadow-xs transition-all duration-200 hover:bg-gray-50 hover:shadow-sm"
			>
				{buttonText}
			</Button>
		</div>
	);
};
